export default __webpack_public_path__ + "static/media/glasses.b29a7079.svg";